webpackJsonp([41],{

/***/ 1037:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_bar_vue__ = __webpack_require__(836);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d7285a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_bar_vue__ = __webpack_require__(1040);
function injectStyle (ssrContext) {
  __webpack_require__(1038)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d7285a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d7285a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1038:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1039);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("0887979e", content, true, {});

/***/ }),

/***/ 1039:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.action-bar-container[data-v-6d7285a6]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:100vh;position:absolute;top:0;right:-8px;z-index:3}.action-bar[data-v-6d7285a6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column}.action-bar-element[data-v-6d7285a6]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;border:1px solid color(blue-price);border-radius:4px;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.5);box-shadow:0 2px 4px 0 rgba(0,0,0,.5);color:color(subheaderText);display:grid;font-size:12px!important;grid-template-columns:30px 1fr;grid-template-rows:40px;margin-bottom:5px;padding:0 11px;text-align:left;-webkit-transform:translateX(70px);transform:translateX(70px);-webkit-transition:-webkit-transform .2s ease-out;transition:-webkit-transform .2s ease-out;transition:transform .2s ease-out;transition:transform .2s ease-out,-webkit-transform .2s ease-out;width:120px}.action-bar-icon[data-v-6d7285a6]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:24px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;width:24px}.action-bar-icon img[data-v-6d7285a6]{height:24px;-o-object-fit:contain;object-fit:contain;position:absolute;width:24px}.action-bar-icon img.is-hidden[data-v-6d7285a6]{display:none}.action-bar-element[data-v-6d7285a6]:hover{-webkit-transform:translateX(-6px);transform:translateX(-6px)}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/action-bar.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,uCAAuC,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,aAAa,kBAAkB,MAAM,WAAW,SAAS,CACtN,AACD,6BAA6B,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,qBAAqB,gBAAgB,CAC/K,AACD,qCAAqC,yBAAyB,sBAAsB,mBAAmB,sBAAsB,mCAAmC,kBAAkB,8CAA8C,sCAAsC,2BAA2B,aAAa,yBAA0B,+BAA+B,wBAAwB,kBAAkB,eAAe,gBAAgB,mCAAmC,2BAA2B,kDAAoD,0CAA4C,kCAAoC,iEAAsE,WAAW,CAClsB,AACD,kCAAkC,yBAAyB,sBAAsB,mBAAmB,2BAA2B,2BAA2B,oBAAoB,YAAY,wBAAwB,qBAAqB,uBAAuB,kBAAkB,UAAU,CACzR,AACD,sCAAsC,YAAY,sBAAsB,mBAAmB,kBAAkB,UAAU,CACtH,AACD,gDAAgD,YAAY,CAC3D,AACD,2CAA2C,mCAAmC,0BAA0B,CACvG","file":"action-bar.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.action-bar-container[data-v-6d7285a6]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:100vh;position:absolute;top:0;right:-8px;z-index:3\n}\n.action-bar[data-v-6d7285a6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column\n}\n.action-bar-element[data-v-6d7285a6]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;border:1px solid color(blue-price);border-radius:4px;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.5);box-shadow:0 2px 4px 0 rgba(0,0,0,.5);color:color(subheaderText);display:grid;font-size:12px !important;grid-template-columns:30px 1fr;grid-template-rows:40px;margin-bottom:5px;padding:0 11px;text-align:left;-webkit-transform:translateX(70px);transform:translateX(70px);-webkit-transition:-webkit-transform 200ms ease-out;transition:-webkit-transform 200ms ease-out;transition:transform 200ms ease-out;transition:transform 200ms ease-out, -webkit-transform 200ms ease-out;width:120px\n}\n.action-bar-icon[data-v-6d7285a6]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:24px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;width:24px\n}\n.action-bar-icon img[data-v-6d7285a6]{height:24px;-o-object-fit:contain;object-fit:contain;position:absolute;width:24px\n}\n.action-bar-icon img.is-hidden[data-v-6d7285a6]{display:none\n}\n.action-bar-element[data-v-6d7285a6]:hover{-webkit-transform:translateX(-6px);transform:translateX(-6px)\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1040:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-bar-container"},[_c('div',{staticClass:"action-bar"},_vm._l((_vm.actions),function(action,index){return _c('button',{key:index,class:{ active: action.active },attrs:{"type":"button"},on:{"click":function($event){return _vm.actionToDo(action)}}},[_c('div',{staticClass:"action-bar-element"},[_c('span',{staticClass:"action-bar-icon"},[_c('v-icon',[_vm._v(_vm._s(action.icon || 'extension'))]),_vm._v(" "),(action.img)?_c('img',{attrs:{"src":action.img,"alt":""},on:{"error":_vm.hideBrokenIcon}}):_vm._e()],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(action.text))])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1041:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header-page',{attrs:{"name":"Configuration","title":_vm.$route.meta.title}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('action-bar',{attrs:{"actions":_vm.actions},on:{"open-modal":_vm.openModal}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_configuration_vue__ = __webpack_require__(835);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c260edc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_configuration_vue__ = __webpack_require__(1041);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_configuration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c260edc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_configuration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_action_bar__ = __webpack_require__(1037);
//
//
//
//
//
//
//
//
//
//
//
//
//



function openModal() {
	if (this.$route.name === 'page-config-dealers') {
		this.goTo('page-dealers-new');
	} else {
		this.goTo('page-implementers-create');
	}
}

function data() {
	return {
		actions: [{
			id: 1,
			code: 'CU',
			text: 'Crear Usuario',
			icon: 'settings',
			active: true
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		actionBar: __WEBPACK_IMPORTED_MODULE_0__components_shared_action_bar__["a" /* default */]
	},
	data: data,
	name: 'page-configuration',
	methods: {
		openModal: openModal
	}
});

/***/ }),

/***/ 836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function actionToDo(item) {
	var newObject = {
		width: item.width ? item.width : 0,
		title: item.text,
		code: item.code,
		active: item.active,
		open: true
	};
	var action = item.link || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newObject);
	var eventEmit = item.link ? 'to-link' : 'open-modal';
	this.$emit(eventEmit, action);
}

function hideBrokenIcon(_ref) {
	var target = _ref.target;

	target.classList.add('is-hidden');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'action-bar',
	methods: {
		actionToDo: actionToDo,
		hideBrokenIcon: hideBrokenIcon
	},
	props: {
		actions: Array
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/41.959fb6359979bc49dc88.js